<template>
    <div v-if="result" class="body-initial">
        <Header/>
        <div class="container">
            <div class="row  justify-content-center">
                <div class="col-8">
                    <div class="text-center mb-3" >
                        <button type="submit" class="btn btn-add-user navbar-button" data-bs-toggle="modal" data-bs-target="#addUserModal">Añadir Usuario</button>
                        <div class="modal fade" id="addUserModal" style="border-radius: 24px;" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div class="modal-dialog  modal-lg">
                                    <div class="modal-content" style=" border: 1px solid #3E3E3E;">
                                        <div class="modal-header">
                                            <h3 class="modal-title col-11 text-center" id="exampleModalLabel">Añadir nuevo usuario</h3>
                                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                        </div>
                                        <div class="modal-body modal-padding-body mx-5 text-center">
                                            <form action="" class="form-vertical">
                                                <div class="form-group center mb-4">
                                                    <label for="" class="control-label col-sm-5">Nombre *</label>
                                                    <div class="col-sm-12">
                                                        <input type="text" style="text-align: left" placeholder="Introduce el nombre del usuario" class="form-control input" name="name" id="name" required v-model="userBasicData.firstName">
                                                    </div>
                                                </div>
                                                <div class="form-group center mb-4">
                                                    <label for="" class="control-label col-sm-5">Apellidos *</label>
                                                    <div class="col-sm-12">
                                                        <input placeholder="Introduce los apellidos del usuario" type="text" style="text-align: left" class="form-control input" name="lastName" id="lastName" 
                                                        required
                                                        v-model="userBasicData.lastName">
                                                    </div>
                                                </div>
                                                <div class="form-group center mb-4">
                                                <label for="" class="control-label col-sm-5">Email *</label>
                                                <div class="col-sm-12">
                                                        <input placeholder="Introduce el email" type="text" style="text-align: left; width:50%" class="col-6 input" v-model="userBasicData.mail" required>
                                                            <select class="select-center col-6"  v-model="userBasicData.domainMail">
                                                            <option disabled value="">Elije dominio</option>
                                                            <option>@elcorteingles.es</option>
                                                            <option>@eci.es</option>
                                                            </select>
                                                </div>
                                                </div>
                                                <div class="form-group center mb-4">
                                                    <label for="" class="control-label col-sm-5">Contraseña *</label>
                                                    <div class="col-sm-12">
                                                        <input required type="password" style="text-align: left" class="form-control input" placeholder="Introduce la contraseña para el usuario" name="password" id="password" v-model="userBasicData.password">
                                                    </div>
                                                </div>
                                                    <div class="form-group center mb-4">
                                                        <label for="" class="control-label col-sm-5">Centro *</label>
                                                        <div class="col-sm-12">
                                                            <select  class="select-center" name="select" v-model="userBasicData.account_id"> 
                                                            <option v-for="cent in centerList" :key="cent.account_id" 
                                                            v-bind:value="cent.accountID">
                                                                {{cent.accountName}}</option>    
                                                            </select>
                                                        </div>
                                                    </div>
                                                
                                            </form>
                                        </div>
                                        <div class="modal-footer  justify-content-center">
                                            <button type="button" class="btn btn-secondary navbar-button config" data-bs-dismiss="modal">Cancelar</button>
                                            <button type="submit" class="btn btn-danger  navbar-button guardar" v-on:click="saveNewUser(userBasicData)">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                    <nav class="navbar container-fluid">
                    <div class="row">
                        <form class="col-7 d-inline-flex">
                            <input class="form-control navbar-button me-2 input" type="search"  placeholder="Buscar usuario" aria-label="Search" v-model="term">
                            <button class="btn btn-search btn-outline-success" style="display:none" type="submit" v-on:click.prevent="searchUser()">Buscar</button>
                        </form>

                        <div class="dropdown col-3" style="text-align: right;">
                            <button class="btn btn-secondary navbar-button dropdown-toggle content config" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                Centros
                            </button>
                            <ul class="dropdown-menu  scrollable-menu" aria-labelledby="dropdownMenuButton1">
                                <li v-for="cent in centerList" :key="cent.account_id" v-on:click="searchUsersPerAccount(cent.accountID, cent.accountName)">
                                    <a class="dropdown-item" href="#">{{cent.accountName}}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-2" style="text-align: right;">
                            <button class="btn btn-secondary navbar-button content config" type="button" v-on:click="changePage(1)">
                                Limpiar
                            </button>
                        </div>
                        

                    </div>
                </nav>
                <h4 class="my-3" v-if="this.showAccount">
                    {{this.accountNameSelected}}
                </h4>
            
            <table class="table tabla table-hover" style="width:100%" >
                <thead>
                    <tr>
                    <th  scope="col mx-2">User</th>
                    <th scope="col">Status</th>
                    <th  scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(user , index) in usersList" :key="index">
                        <td  class="user-column">{{user.userMail}}</td>
                        <td >
                            <div class="" v-if="user.userActive==1">
                                <label class="form-check-label mx-2" for="flexCheckChecked" style="color: #008C2E; text-align:left">
                                    Activo
                                </label>
                                <input class="form-check-input active" type="checkbox" value="" id="flexCheckChecked" checked v-on:click="activate(user.userID, index)">
                            </div>
                            <div class="" v-else>
                                <label class="form-check-label mx-2" for="flexCheckChecked" style="color: #3E3E3E">
                                    Inactivo
                                </label>
                                 <input class="form-check-input inactive" type="checkbox" value="" id="flexCheckChecked" v-on:click="activate(user.userID, index)" >
                            </div>
                        </td>
                        <td >
                            <button type="button" class="btn btn-secondary btn-sm config mx-1" data-bs-toggle="modal" data-bs-target="#configModal" v-on:click="actualUser(user.userMail, user.userID)" >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-gear-fill" viewBox="0 0 16 16">
                                <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"/>
                                </svg>
                            </button>
                            <button type="button" class="btn btn-secondary btn-sm config mx-1" data-bs-toggle="modal" data-bs-target="#passwordModal" v-on:click="actualUser(user.userMail, user.userID)">
                               <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-key-fill" viewBox="0 0 16 16">
                                <path d="M3.5 11.5a3.5 3.5 0 1 1 3.163-5H14L15.5 8 14 9.5l-1-1-1 1-1-1-1 1-1-1-1 1H6.663a3.5 3.5 0 0 1-3.163 2zM2.5 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                                </svg>
                            </button>
                            <button type="button" class="btn btn-danger btn-sm trash mx-1" v-on:click="deleteUser(user.userID)">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                                <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                                </svg>
                            </button>
                            
                            <div class="modal fade" id="passwordModal" >
                                <div class="modal-dialog">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title col-11 text-center" >CAMBIO DE CONTRASEÑA</h5>
                                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                        </div>
                                        <div class="modal-body">
                                            <div class="col-12">
                                                <div class=" col-12 justify-content-center">
                                                    <label class="label-modal">Email</label>
                                                    <div class="col-12">
                                                        <span>{{userSelected}}</span>
                                                    </div>
                                                </div>
                                                 <div class="col-12 my-5">
                                                    <label class="label-modal">Centro actual</label>
                                                    <div>
                                                        <span>{{center}}</span>
                                                    </div>
                                            </div>
                                            <div class="col-12 mt-5">
                                            <label class="label-modal">Nueva contraseña</label>
                                                   <input
                                                    type="password"
                                                    style="text-align: left"
                                                    class="form-control input text-center"
                                                    placeholder="Insert new password"
                                                    name="password"
                                                    v-model="userCredentials.newpassword"
                                                    /> 
                                                </div>
                                            </div>
                                            <br>
                                        </div>
                                        <div class="modal-footer justify-content-center">
                                        <button type="button" class="btn btn-secondary navbar-button config" data-bs-dismiss="modal">Cancelar</button>
                                            <button type="submit" class="btn btn-danger navbar-button guardar"  v-on:click="editPass()" data-bs-dismiss="modal" >Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="modal fade" id="configModal" >
                                <div class="modal-dialog">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title col-11 text-center" >CONFIGURACIÓN DEL PERFIL</h5>
                                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                        </div>
                                        <div class="modal-body mx-5 text-center">
                                            <div>
                                                <label class="label-modal">Email</label>
                                                <div>
                                                    <span>{{userSelected}}</span>
                                                </div>
                                            </div>
                                            <div class="col-12 my-5">
                                                <label class="label-modal ">Nombre y Apellidos</label>
                                                <div>
                                                    <span>{{personalData}}</span>
                                                </div>
                                            </div>
                                            
                                            <div class="col-12 my-5">
                                                <label class="label-modal">Centro actual</label>
                                                <div>
                                                    <span>{{center}}</span>
                                                </div>
                                            </div>
                                            <div> 
                                                <label class="label-modal">Nuevo centro</label>
                                                <div>
                                                    <select required name="select" class="select-center" v-model="transfer.newCenter" > 
                                                        <option v-for="cent in centerList" :key="cent.accountID" v-bind:value="cent.accountID">
                                                            {{cent.accountName}}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <br>      
                                        </div>
                                        <div class="modal-footer justify-content-center">
                                        <button type="button" class="btn btn-secondary navbar-button config" data-bs-dismiss="modal">Cancelar</button>
                                            <button type="submit" class="btn btn-danger navbar-button guardar"  v-on:click="saveNewCenter(userIDSelected)" data-bs-dismiss="modal">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>  
            </table>
            <br>
            <nav v-if="this.pagination" >
                <ul class="pagination text-center" >
                    <li class="page-item" v-on:click="changePage(1)" ><a href="#" class="page-link pagination" >Pagina Inicial</a></li>
                    <li class="page-item">
                    <a class="page-link pagination"  aria-label="Previous" a href="#" v-on:click="changePage(pagina - 1)"> 
                        <span aria-hidden="true">&laquo;</span>
                        <span class="sr-only"></span>
                    </a>
                    </li>
                    <li class="page-item"><a class="page-link pagination" >{{pagina}}</a></li>
                    <li class="page-item" v-if="this.enableButtonNext">
                    <a class="page-link pagination" a href="#" aria-label="Next" v-on:click="changePage(pagina + 1)">
                        <span aria-hidden="true">&raquo;</span>
                        <span class="sr-only"></span>
                    </a>
                    </li>
                </ul>
            </nav>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header.vue';
import axios from 'axios'
export default {
    name:'Dashboard',
    data(){
        return{
            userSelected:null,
            userIDSelected:null,
            usersList:null,
            pagina: 1,
            registrosTotales:1,
            user:[],
            token:"",
            valido:null,
            mail:"",
            result:null,
            term:"",
            showAccount:false,
            accountNameSelected:"",
            accountIDSelected:"",
            center:"",
            userID:null,
            enableButtonNext: true,
            pagination:null,
            userBasicData:{
                active:true,
                userType:"client",
                firstName:"",
                lastName:"",
                mail:"",
                password:"",
                account_id:"",
                domainMail:''
            },
            transfer:{
                newCenter:"",
                changeID:"",
            },
            centerList:null,
            userCredentials: {
                id: "",
                newpassword: "",
            },
            personalData:"",
            searchByCenter:false,
            searchResultCount:null
            }
    },
    components:{
        Header,
    },
    created(){
        this.getAllCenters();
        this.getAllData(this.pagina);
    },
    methods:{
        getAllCenters(){
        let dirección ="https://eciadmin.roombox3d.com/users.php";
            axios.get(dirección).then((datos) => {
                this.centerList=datos.data;
            });

        },
        userCenter(){
            let dirección =
            "https://eciadmin.roombox3d.com/users.php?mail=" + this.userSelected;
            axios.get(dirección).then((datos) => {
                this.personalData=datos.data.user.Contact.fullname;
                this.center = datos.data.user.Account.name;
            });
            this.getAllCenters();
        },

        getAllData(){
            this.token=localStorage.token;
            let direcciónToken="https://eciadmin.roombox3d.com/users.php?token=" + this.token;
            axios.get(direcciónToken).then(data=>{
                this.valido=data.data.statusMsg.status;
                if(this.valido){
                    this.searchByCenter=false;
                    let dirección="https://eciadmin.roombox3d.com/users.php?page=" + this.pagina;
                    axios.get(dirección).then(data=>{
                        this.result=data.data;
                        this.registrosTotales=data.data.length;
                        this.usersList=data.data;
                        this.pagination=true;
                        this.showAccount=false;
                        this.term="";
                        this.accountNameSelected="";
                        if(this.registrosTotales<10){
                            this.enableButtonNext=false;
                        }
                        
                    })
                }
                else{
                    alert("La sesión ha expirado, por favor, haz login de nuevo.")
                    this.$router.push('/');
                }
                
            })
        },

        
        saveNewCenter(user){ 
            if(this.transfer.newCenter!=""){
                this.transfer = {
                    "newCenter": this.transfer.newCenter,
                    "changeID": user,
                };
                axios.post("https://eciadmin.roombox3d.com/users.php", this.transfer)
                .then((datas) => {
                        console.log(datas);
                        alert("El centro ha sido cambiado");
                        });
                this.transfer.newCenter="";
                
            }
            else{
                alert("El nuevo centro no puede ser vacío, inserte el nuevo centro o pulse cancelar.")
            }
        },
        changePage(page){
            if(page>=1 && this.enableButtonNext){
                this.searchByCenter=false;
                this.enableButtonNext=true;
                this.pagina = page;
                this.getAllData();
                }
                else if(page<this.pagina && page>=1){
                    this.enableButtonNext=true;
                    this.pagina=page;
                    this.getAllData();
                }
        },
        searchUser(busqueda){
            busqueda=this.term;
            var accountID="";
            this.pagination=true;
            if(busqueda=="" && !this.searchByCenter){
                this.getAllData();
            }
            else{
                if(this.searchByCenter){
                    accountID=this.accountIDSelected;
                }
                this.pagination=false;
                let direcciónToken="https://eciadmin.roombox3d.com/users.php?term=" + busqueda + '&center='+accountID;
                axios.get(direcciónToken).then(data=>{
                if(data.data.length>0){
                    this.usersList=data.data;
                    if(data.data.length==1){
                        this.searchResultCount=1;
                    }
                }else{
                    alert ("No se ha encontrado el email. Intentalo de nuevo");
                }
                });
            } 
        },
        saveNewUser(datosUsuario){
            if(datosUsuario.account_id=="" || datosUsuario.firstName=="" || datosUsuario.lastName=="" || datosUsuario.mail=="" || datosUsuario.password=="" || datosUsuario.domainMail=="" ){
                alert ("Inserta todos los datos obligatorios");
            }
            else{
                
                axios.post("https://eciadmin.roombox3d.com/users.php", datosUsuario)
                .then((datos) => {
                    if(datos.data.statusMsg.status){
                        alert("Usuario creado correctamente");
                        datosUsuario.account_id='';
                        datosUsuario.firstName='';
                        datosUsuario.lastName='';
                        datosUsuario.mail='';
                        datosUsuario.password='';
                        datosUsuario.domainMail='';
                    }
                    else{
                        alert(datos.data.statusMsg.message);
                    }

                });
            }
            
        },
        activate(id, pos){
            let dirección ="https://eciadmin.roombox3d.com/users.php?id=" + id;
            axios.get(dirección).then((datos) => {
                if(datos.data.statusMsg.status){
                    if(this.usersList[pos].userActive==0){
                        this.usersList[pos].userActive=1;
                    }else{
                        this.usersList[pos].userActive=0;
                    }
                }else{
                    alert("No se ha podido completar la solicitud");
                }
            });
        },
        deleteUser(id){
            var enviar = {
                "userID":id
            };
            var bool=confirm("¿Deseas eliminar este usuario?");
            if(bool){
                axios.delete("https://eciadmin.roombox3d.com/users.php", { headers : enviar})
                .then( datos => {
                    console.log(datos);
                    alert("Usuario eliminado");
                    if(this.searchResultCount==0 || this.searchResultCount==1 && !this.searchByCenter){
                        this.getAllData();
                        
                    }
                    else if(this.searchByCenter){
                        this.searchUsersPerAccount( this.accountIDSelected, this.accountNameSelected);
                    }else{
                        this.searchUser(this.term);
                    }
                    
            });
            }
        },
        editPass() {
            this.userCredentials.id=this.userIDSelected;
            if (this.userCredentials.newpassword != "") {
                this.userCredentials = {
                    id: this.userCredentials.id,
                    newpassword: this.userCredentials.newpassword,
                };
                var bool=confirm("¿Estas segur@ de cambiar la contraseña?");
                if(bool){
                    axios
                        .post("https://eciadmin.roombox3d.com/users.php", this.userCredentials)
                        .then((datas) => {
                        console.log(datas);
                        alert("Tu contraseña ha sido guardada");
                        });     
                    }
            }
            this.userCredentials.newpassword="";
        },
        searchUsersPerAccount(accountID,accountName){
            let dirección="https://eciadmin.roombox3d.com/users.php?accountID=" + accountID;
                axios.get(dirección).then(data=>{
                    this.registrosTotales=0;
                    this.pagination=false;
                    this.usersList=data.data;
                    this.showAccount=true;
                    this.accountNameSelected=accountName;
                    this.accountIDSelected=accountID;
                    this.searchByCenter=true;
                })
        },
        actualUser(user,iduser){
            this.userSelected=user;
            this.userIDSelected=iduser;
            this.userCenter();
            
        }
    }
}
</script>

<style >


</style>